import Vue from 'vue';
import format from 'date-fns/format';

export const supplierContactsListingService = {
  async retrieveSupplierContacts(activeInactive, sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/supplier-contacts/list', {
        params: {
          activeInactive,
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadSupplierContactsXlsx(activeInactive, sortParams, pagingParams) {
    const response = await Vue.axios({
      url: `/supplier-contacts/xlsx`,
      method: 'GET',
      params: {
        activeInactive,
        ...sortParams,
        ...pagingParams
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `SupplierContacts-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  },

  async retrieveRecordCount(activeInactive, searchParam) {
    return Vue.axios
      .get('/supplier-contacts/count-records', {
        params: { activeInactive, searchParam }
      })
      .then(response => response.data);
  }
};
